import { GET_NEW_PROJECT_USERS, GET_NEW_PROJECT_USERS_ERR } from '../../actionTypes/projectType'
import { newProjectUsersApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const newProjectUsers = (payload) => async (dispatch) => {
    try {
        let results = await axios.get(`${newProjectUsersApi}/${payload.project_id}/${payload.page}`, await accessToken())
        let data = results && results.data
        console.log('GET ASSIGN PROJECTS', data)
        dispatch({
            type: GET_NEW_PROJECT_USERS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_NEW_PROJECT_USERS_ERR,
            payload: error.response,
        });
    }
};


